module.exports = __webpack_public_path__ + "img/not-found.88e398ea.svg";